<div class="list-view-grid-wrapper" [attr.data-test]="'list-view-grid'">
  <div *ngIf="!hideLoader" [hidden]="!state.isLoading" class="list-view-grid-loader">
    <dojo-loader />
  </div>

  <ng-container *ngIf="state.initialized">
    <ag-grid-angular
      *ngIf="state.renderAgGrid"
      class="list-view-grid transparent-background"
      @appearDisappear
      [gridOptions]="gridOptions()"
      [columnDefs]="columnDefs"
      [rowData]="state.data"
      [components]="components"
      [ngClass]="[agGridClass, agGridAdditionalClass || '']"
      (gridReady)="onGridReady($event)"
      (rowClicked)="rowClicked($event)"
      (rowDoubleClicked)="rowDoubleClicked($event)"
      (selectionChanged)="gridSelectionChanged.emit($event)"
      (cellClicked)="cellClicked.emit($event)"
    >
    </ag-grid-angular>

    <dojo-empty-state
      *ngIf="!state.isLoading && !state.hasData"
      [addButtonLabel]="addButtonTmpl"
      [header]="messages?.noDataHeader ?? ''"
      [body]="messages?.noDataBody ?? ''"
      data-test="list-view-grid-empty-table"
    >
    </dojo-empty-state>

    <ng-template #addButtonTmpl>
      <div matTooltip *ngIf="canAdd && messages?.addButtonLabel">
        <dojo-button (click)="add.emit()" [attr.data-test]="'list-view-grid-button-add-item'">
          {{ messages?.addButtonLabel || 'Add item' }}
        </dojo-button>
      </div>
    </ng-template>
  </ng-container>
</div>
